export const combinedDirections = [
    'up',
    'up left',
    'up right',
    'down',
    'down left',
    'down right',
    'left',
    'left up',
    'left down',
    'right',
    'right up',
    'right down',
];
export const mainDirections = ['up', 'down', 'left', 'right'];
export const offsetDirections = [
    'offsetLeft',
    'offsetRight',
    'offsetUp',
    'offsetDown',
];
export const centering = ['verticalCenter', 'horizontalCenter'];
//# sourceMappingURL=types.js.map